import { render, staticRenderFns } from "./DatePickerDOB.vue?vue&type=template&id=08020612"
import script from "./DatePickerDOB.vue?vue&type=script&lang=js"
export * from "./DatePickerDOB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports